var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2978)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A9612C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F17B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0056 11.99H16.2806V10.82C16.7506 10.82 17.1256 10.78 17.4056 10.7C17.6956 10.62 17.9256 10.49 18.0956 10.31C18.2656 10.12 18.4156 9.85 18.5456 9.5H19.6556V20H18.0056V11.99ZM21.7014 18.41H23.2914V20H21.7014V18.41ZM26.8536 20.15C26.0536 20.15 25.4436 19.925 25.0236 19.475C24.6036 19.015 24.3936 18.36 24.3936 17.51V17.315H25.9536V17.615C25.9536 18.305 26.2386 18.65 26.8086 18.65C27.1186 18.65 27.3486 18.555 27.4986 18.365C27.6486 18.175 27.7236 17.84 27.7236 17.36V15.35H27.6936C27.4036 15.96 26.9036 16.265 26.1936 16.265C25.5936 16.265 25.1386 16.06 24.8286 15.65C24.5186 15.24 24.3636 14.645 24.3636 13.865V11.99C24.3636 11.15 24.5786 10.5 25.0086 10.04C25.4386 9.58 26.0586 9.35 26.8686 9.35C27.6786 9.35 28.2986 9.58 28.7286 10.04C29.1586 10.5 29.3736 11.15 29.3736 11.99V17.42C29.3736 19.24 28.5336 20.15 26.8536 20.15ZM26.8686 14.765C27.4386 14.765 27.7236 14.42 27.7236 13.73V11.87C27.7236 11.19 27.4386 10.85 26.8686 10.85C26.2986 10.85 26.0136 11.19 26.0136 11.87V13.73C26.0136 14.42 26.2986 14.765 26.8686 14.765Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2978",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2978",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg19);
export default __webpack_public_path__ + "static/media/19.d21d98eb49ab03a4eae26b3c5273f246.svg";
export { ForwardRef as ReactComponent };